import React, { useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import styles from './CloudServiceConnector.module.css';

// Dropbox SVG Icon
const DropboxIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 1.807L0 5.629l6 3.822 6.001-3.822L6 1.807zM18 1.807l-6 3.822 6 3.822 6-3.822-6-3.822zM0 13.274l6 3.822 6.001-3.822L6 9.452l-6 3.822zM18 9.452l-6 3.822 6 3.822 6-3.822-6-3.822zM6 18.371l6.001 3.822 6-3.822-6-3.822L6 18.371z" />
  </svg>
);

// Google Drive SVG Icon
const GoogleDriveIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.71 3.5L1.76 15l4.13 7.5H14L7.71 3.5zM22.24 15H9.88l-2.13 3.75h14.49L22.24 15zM14 3.5l6.29 11.5L16.16 22.5H22.24L28 15l-7.71-11.5H14z" />
  </svg>
);

const cloudServices = [
  {
    id: 'dropbox',
    name: 'Dropbox',
    icon: DropboxIcon,
    color: '#0061FF',
    enabled: true,
  },
  {
    id: 'googledrive',
    name: 'Google Drive',
    icon: GoogleDriveIcon,
    color: '#4285F4',
    enabled: true,
  },
];

export const CloudServiceConnector = ({ connectedServices, onDisconnect }) => {
  const handleConnect = async (serviceId) => {
    if (serviceId === 'dropbox') {
      // Dropbox OAuth configuration
      const clientId = 'xycymyua8j9yykw';
      const redirectUri = `${window.location.origin}/cloud-upload`;
      const state = Math.random().toString(36).substring(7); // Random state for security

      // Store state in sessionStorage for verification
      sessionStorage.setItem('dropboxOAuthState', state);

      // First logout from Dropbox to clear session, then redirect to auth
      const logoutUrl = 'https://www.dropbox.com/logout';
      const authUrl = `https://www.dropbox.com/oauth2/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(redirectUri)}&state=${state}&force_reapprove=true&force_reauthentication=true`;

      // Open logout in hidden iframe, then redirect
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = logoutUrl;
      document.body.appendChild(iframe);

      // Wait a moment for logout, then redirect to auth
      setTimeout(() => {
        document.body.removeChild(iframe);
        window.location.href = authUrl;
      }, 1000);
    } else if (serviceId === 'googledrive') {
      // Google Drive OAuth configuration
      const clientId = '526946985013-7ol8pss03r4cd6dqbijso7a4pfrgnhsi.apps.googleusercontent.com';
      const redirectUri = `${window.location.origin}/cloud-upload`;
      const state = Math.random().toString(36).substring(7); // Random state for security
      const scope = 'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/userinfo.email';

      // Store state in sessionStorage for verification
      sessionStorage.setItem('googleDriveOAuthState', state);

      // Construct Google OAuth URL
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=token&scope=${encodeURIComponent(scope)}&state=${state}&include_granted_scopes=true`;

      // Redirect to Google authorization page in the same window
      window.location.href = authUrl;
    }
  };

  const handleDisconnect = (serviceId) => {
    onDisconnect(serviceId);
  };

  return (
    <div className={styles.container}>
      <div className={styles.servicesGrid}>
        {cloudServices.map((service) => {
          const IconComponent = service.icon;
          const isConnected = connectedServices[service.id];

          return (
            <div
              key={service.id}
              className={`${styles.serviceCard} ${isConnected ? styles.serviceCardConnected : ''} ${!service.enabled ? styles.serviceCardDisabled : ''}`}
              style={{
                '--service-color': service.color,
              }}
            >
              <div className={styles.serviceIcon} style={{ color: service.color }}>
                <IconComponent />
              </div>

              <div className={styles.serviceContent}>
                <div className={styles.serviceHeader}>
                  <div className={styles.serviceInfo}>
                    <h3 className={styles.serviceName}>{service.name}</h3>
                    {isConnected && (
                      <p className={styles.serviceEmail}>{isConnected.email || 'Connected'}</p>
                    )}
                    {!service.enabled && (
                      <p className={styles.comingSoon}>Coming Soon</p>
                    )}
                  </div>

                  <div className={styles.serviceActions}>
                    {service.enabled && !isConnected && (
                      <button
                        className={styles.connectButton}
                        onClick={() => handleConnect(service.id)}
                      >
                        Connect
                      </button>
                    )}
                  </div>
                </div>

                {service.enabled && isConnected && (
                  <div className={styles.connectedActions}>
                    <div className={styles.connectedBadge}>
                      <CheckCircleIcon style={{ fontSize: 18 }} />
                      <span>Connected</span>
                    </div>
                  </div>
                )}
              </div>

              {service.enabled && isConnected && (
                <button
                  className={styles.disconnectButton}
                  onClick={() => handleDisconnect(service.id)}
                  aria-label="Disconnect"
                >
                  <LinkOffIcon style={{ fontSize: 14 }} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
